export default __webpack_public_path__ + "static/white-i-phone-ff6dcd8446273b7d9df2f2e832287214.svg";